import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import "./styles.css";

const LanguageToggle = ({ languages, activeLanguage, setActiveLanguage }) => (
  <UncontrolledDropdown nav inNavbar direction="up">
    <DropdownToggle nav>
      <Translate id="LanguageText" />
    </DropdownToggle>
    <DropdownMenu className="lang-dropdown">
      {languages.map(lang => (
        <DropdownItem key={lang.code}>
          <a
            className="dropdown-menu-link"
            onClick={() => setActiveLanguage(lang.code)}
          >
            {lang.label}
          </a>
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default withLocalize(LanguageToggle);



// WEBPACK FOOTER //
// ./src/components/LanguageToggle/LanguageToggle.js